import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../auth.service';
import {AppConstants} from './app.constants';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';

@Injectable()
export class UserService {

  constructor(private http: HttpClient, private auth: AuthService, private appConstants: AppConstants) {
  }

  getUserData(userId): Observable<any> {
    return this.http.get(environment.apiBase + `freelancers/${userId}`, {headers: this.auth.getAuthorizationHeaders()})
      .map(r => r)
      .catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shared/user.service.ts